import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

var card_sliders = document.querySelectorAll( '.card-slider--block.splide' );

for ( var i = 0; i < card_sliders.length; i++ ) {

    // https://splidejs.com/guides/options/
    const slider = card_sliders[ i ];

    var args = {
        type   : 'loop',
        perPage: 3,
        perMove: 1,
        gap: '1.5rem',
        arrows: true,
        pagination: false,
        breakpoints:{
            800:{
                perPage: 2,
                padding:{
                    right: 90
                }
            },
            600:{
                perPage: 1,
                padding:{
                    right: 120
                }
            }
        }
    };

    if( slider.classList.contains('alignfull') ){
        args.padding = { right: 180 }
    }

    if( "1" == slider.dataset.autoplay ){
        args.drag = 'free';
        args.autoScroll = {
            speed: 0.75,
            pauseOnHover: true,
            pauseOnFocus: false,
            breakpoints:{
                800:{
                    perPage: 2
                },
                600:{
                    perPage: 1
                }
            }
        }
        new Splide( slider, args ).mount({ AutoScroll });
    }else{
        new Splide( slider, args ).mount();
    }

}